import axios from 'axios';
import  Storage from './storage';
import Vue from 'vue';

require('dotenv').config();

let TokenStorage = new Storage
let TOKEN        = ()=>{
    return `Bearer ${TokenStorage.getItem('image_analysis_token')}`
}

let FlaskApi     = axios.create({
	baseURL: process.env.VUE_APP_IMAGE_ANALYST_API,
	timeout: 1000,
	withCredentials: true,
	headers: {
    	'Content-Type': 'application/json',
		'Authorization': TOKEN()
	}
});

let getNewToken = () => {

	return FlaskApi.post('/auth',{

		username:process.env.VUE_APP_IMAGE_ANALYST_USERNAME,
		password:process.env.VUE_APP_IMAGE_ANALYST_PASSWORD

	}).then( response => {

        TokenStorage.setItem('image_analysis_token',response.data.access_token)

        return response.data

    }).catch( error => { throw error } )

}

FlaskApi.interceptors.response.use( (response) => {
    return response;
}, (error) => {

    if(error.response.status == 422){

        Vue.toasted.show(error.message, { 
            type: 'success',
              theme: "toasted-primary", 
              position: "top-right", 
              duration : 2500,
        });

    }

    if (error.response.status !== 401 && TokenStorage.getItem('image_analysis_token') != null) {
    	return new Promise((resolve, reject) => {
    		reject(error);
    	});
    }

    // Logout user if token refresh didn't work or user is disabled
    if (error.config.url == '/auth/refresh' || error.response.message == 'Account is disabled.') {

    	TokenStorage.clear();

    	return new Promise((resolve, reject) => {
    		reject(error);
    	});

    }

    getNewToken().then( response => {

        error.config.headers = {
            'Content-Type': 'application/json',
            'Authorization': TOKEN()
        }

        return FlaskApi.request(error.config);

    }).catch( error => {throw error} );

});


export default FlaskApi